import {
  legacy_createStore as createStore,
  combineReducers,
  applyMiddleware,
} from "redux";
import thunk from 'redux-thunk';
import { composeWithDevTools } from "redux-devtools-extension";
import { createTransform, persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from './reducers/authReducer';
import displayReducer from "./reducers/displayReducer";
import accountReducer from './reducers/accountReducer';
import { persistedAccountIdentity } from "../utils/residentPaymentSettings";

const middleware = [thunk];

const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["isLoggedIn", "authenticated", "userId", "email", "brandColor"],
};

const accountPersistConfig = {
  key: "account",
  storage,
  whitelist: ["activeAccount"],
  transforms: [createTransform(
    persistedAccountIdentity,
    persistedAccountIdentity,
    { whitelist: ["activeAccount"] },
  )],
};

const switchTabPersistConfig = {
  key: "switchTab",
  storage,
  whitelist: ["commodityRates", "dashboardData"],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  account: persistReducer(accountPersistConfig, accountReducer),
  switchTab: persistReducer(switchTabPersistConfig, displayReducer),
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export const persistor = persistStore(store);
export default store;
